/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProfileFamilyResourceCategoriesInner
 */
export interface ProfileFamilyResourceCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof ProfileFamilyResourceCategoriesInner
     */
    categoryId: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileFamilyResourceCategoriesInner
     */
    label: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileFamilyResourceCategoriesInner
     */
    verticals: Array<ProfileFamilyResourceCategoriesInnerVerticalsEnum>;
}


/**
 * @export
 */
export const ProfileFamilyResourceCategoriesInnerVerticalsEnum = {
    Strategy: 'STRATEGY',
    Freelancer: 'FREELANCER'
} as const;
export type ProfileFamilyResourceCategoriesInnerVerticalsEnum = typeof ProfileFamilyResourceCategoriesInnerVerticalsEnum[keyof typeof ProfileFamilyResourceCategoriesInnerVerticalsEnum];


/**
 * Check if a given object implements the ProfileFamilyResourceCategoriesInner interface.
 */
export function instanceOfProfileFamilyResourceCategoriesInner(value: object): value is ProfileFamilyResourceCategoriesInner {
    if (!('categoryId' in value) || value['categoryId'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('verticals' in value) || value['verticals'] === undefined) return false;
    return true;
}

export function ProfileFamilyResourceCategoriesInnerFromJSON(json: any): ProfileFamilyResourceCategoriesInner {
    return ProfileFamilyResourceCategoriesInnerFromJSONTyped(json, false);
}

export function ProfileFamilyResourceCategoriesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileFamilyResourceCategoriesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'categoryId': json['categoryId'],
        'label': json['label'],
        'verticals': json['verticals'],
    };
}

export function ProfileFamilyResourceCategoriesInnerToJSON(value?: ProfileFamilyResourceCategoriesInner | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'categoryId': value['categoryId'],
        'label': value['label'],
        'verticals': value['verticals'],
    };
}

